import type { SelectHTMLAttributes } from "react";

export interface SelectOption {
  value: string;
  label: string;
}

export interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, "children"> {
  id: string;
  options: SelectOption[];
}

/** 原型基元：`.select-wrap` + `select` + 装饰箭头。 */
export function Select({ id, options, className, ...rest }: SelectProps) {
  return (
    <div className="select-wrap">
      <select id={id} className={className} {...rest}>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <span aria-hidden="true">⌄</span>
    </div>
  );
}
